<template>
	<section class="create-contact-section grid-block">
		<header>
			<span>
				Контакты
			</span>

			<VButton
				theme="link"
				icon-postfix
				:disabled="!showAddContact"
				@click="addContact"
			>
				<template #icon>
					<VIcon material="add" />
				</template>
				Добавить контакт
			</VButton>
		</header>

		<article
			v-if="person.contacts.length === 0"
      class="empty"
		>
			Нет данных
		</article>

		<template v-else>
			<article
				v-for="(contact, index) in person.contacts"
				:key="'person-contact' + index"
        class="contact"
			>
				<div class="inputs">
          <VSelectV2
            v-model="contact.type"
            :data="ContactsService.contactTypes"
            :clearable="false"
            :disabled="contact?.id && contact.id > 0"
            required
          />

          <VInputPhoneNumber
            v-if="contact.type?.id === 'phone'"
            v-model="contact.value"
            :disabled="!contact.type"
            required
            placeholder="Номер телефона"
          />

          <VInput
            v-else
            :disabled="!contact.type"
            v-model="contact.value"
            :placeholder="getContactValuePlaceholder(contact.type)"
            required
          />

          <VInput
            :disabled="!contact.type"
            v-model="contact.comment"
            placeholder="Комментарий"
            :max-length="300"
          />

          <VButton
            @click="deleteContact(contact, index)"
          >
            <template #icon>
              <VIcon
                material="delete"
                theme="outlined"
              />
            </template>
          </VButton>
        </div>

				<div>
					<VCheckbox
						v-model="contact.isPreferred"
					>
						Пометить как приоритетный контакт для связи
					</VCheckbox>
				</div>
			</article>
		</template>

		<footer v-if="!editMode">
			Сначала необходимо создать контактное лицо
		</footer>
	</section>
</template>

<style lang="scss" src="./ContactsSection.scss" />

<script lang="ts">

import Core   from "@/core/Core";
import Person from '@/domains/Persons/Person';
import ContactsService from '@/domains/Contacts/ContactsService';
import Contact from "@/domains/Contacts/Contact";

export default defineComponent({
	name: "ContactsSection",

	props: {
		person: {
			type: Person,
			default: null,
		},
		editMode: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			ContactsService,
		}
	},

	computed: {
		showAddContact() {
			return this.editMode && this.person?.contacts?.length < 21;
		},
	},

	methods: {
		addContact() {
			this.person.contacts.push(new Contact());
		},

    getContactValuePlaceholder(contactType: any) {
      if (this.$core.utils.isNullOrUndefined(contactType?.id)) return null;
      return contactType?.id === 'email' ? 'Почта' : 'Логин';
    },

		async updateContacts() {

			/** чтобы не было на каждое создание/редактирование уведомления,
			 * то выводим один общее уведомление после цикла */

			let hasChanges = false;

			for (const contact of this.person.contacts) {
				if (!contact.id) {
					if (await ContactsService.create(this.person.id, contact)) {
						hasChanges = true;
					}
				} else {
					if (await ContactsService.update(contact)) {
						hasChanges = true;
					}
				}
			}

			/** даже если create, то передаем событие Updated,
			 * контактное лицо обновится и новые контакты будут отображены */

			if (hasChanges) {
				this.$emit(Contact.Events.Updated);
				Core.showNotification.success("Контакты успешно сохранены");
			}
		},

		async deleteContact(contact: Contact, index: number) {
			if (contact.id && await this.$core.dialogs.confirm(
				'Удалить этот контакт?',
				'Удаление контакта',
			)) {
				await ContactsService.delete(contact.id);

				/** событие пробросится и удалит контакт в блоке у контактного лица */

				this.$emit(Contact.Events.Updated);

				/** но в карточке оно еще остается, поэтому удалим из интерфейса,
				 * потом данные обновятся и все встанет как надо */

				this.person.contacts.splice(index, 1);

			} else if (!contact.id) {
				/** если контакт еще не сохранен */
				this.person.contacts.splice(index, 1);
			}
		},
	}
})
</script>

